import { ConnectTypeUperEnum } from '@model/enum/connect-type-user.enum';
import { Router } from '@angular/router';
import { TransitionService } from './../transition.service';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@services/configuration.service';
import { AppUtils } from '@utils/app.utils';
import { Constants, Profile } from '@utils/constants';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, of } from 'rxjs';
import { ErrorMessage } from '@model/error-message';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { SimpleOrder } from '@model/simpleOrder';
import { BilletOrderTypeEnum } from '@model/enum/billet-order-type';
import { SideEnum } from '@model/enum/side.enum';
import { MatDialog } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { ConfigCardsModel } from '@model/config-comp-settings.model';
import { DictionaryError } from 'dictionary-error';
import { LogService } from 'src/app/core/services/log.service';


@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public _urlApiSocket: string;
  private _youtubeApiVrs = 'v3';

  private WORKSPACE_PD_API_USER_PERFIL = Constants.WKS_USER_PROFILE;           // User Workspace profile constant
  private LOGIN_TYPE_ENABLED = environment.LOGIN_TYPE;                         // Login type environment

  public AssessorListClient: any;

  public _authHbLoginType = new BehaviorSubject<number>(0);
  authHbLoginType$ = this._authHbLoginType.asObservable();

  public _authHbLogged = new BehaviorSubject<boolean>(false);
  authHbLogged$ = this._authHbLogged.asObservable();

  public _loggoutSessionExpired = new BehaviorSubject<boolean>(false);
  loggoutSessionExpired$ = this._loggoutSessionExpired.asObservable();

  public _modalBuySellClosed = new BehaviorSubject<boolean>(false);
  modalBuySellClosed$ = this._modalBuySellClosed.asObservable();

  public _wksBackModal = new BehaviorSubject<boolean>(false);
  wksBackModal$ = this._wksBackModal.asObservable();

  public _clientAssessorChangeSelect = new BehaviorSubject<boolean>(false);
  clientAssessorChangeSelect$ = this._clientAssessorChangeSelect.asObservable();

  public _changeAccountBillet = new BehaviorSubject<string>('');
  changeAccountBillet$ = this._changeAccountBillet.asObservable();

  public _clickOpenSideMenu = new BehaviorSubject<number>(0);
  clickOpenSideMenu$ = this._clickOpenSideMenu.asObservable();

  public _changeThemeDarkLight = new BehaviorSubject<number>(0);
  changeThemeDarkLight$ = this._changeThemeDarkLight.asObservable();

  public _negotiationAccountUser = new BehaviorSubject<string>('');
  negotiationAccountUser$ = this._negotiationAccountUser.asObservable();

  public _getWksAfterValidateUser = new BehaviorSubject<boolean>(false);
  getWksAfterValidateUser$ = this._getWksAfterValidateUser.asObservable();

  public _resetNumberSnapDaily = new BehaviorSubject<boolean>(false);
  resetNumberSnapDaily$ = this._resetNumberSnapDaily.asObservable();
  _currentSymbols = [{
    symbol: '',
    using: false,
  }];

  constructor(
    private _configurationService: ConfigurationService,
    private _transitionService: TransitionService,
    private _router: Router,
    private _modalService: MatDialog,
    public _notificationService: NotificationsService,
    private _logSvc: LogService
  ) {
    // TODO: Segunda opção para tratametno do cache do browser
    // console.log(this.getCookieVersionSystem());
    // if (this.getCookieVersionSystem()) {
    //   console.log('POSSUI VERSAO');
    //   if (this.getCookieVersionSystem() !== environment.version) {
    //     console.log('versao diferente');
    //     console.log('URL: ' + window.location.origin + '/login?v=' + environment.version);
    //     window.location.href = window.location.origin + '/login?v=' + environment.version;
    //     this.setCookieVersionSystem();
    //   } else {
    //     console.log('versao igual');
    //     const url: string = this._router.url.substring(0, this._router.url.indexOf('?'));
    //     this._router.navigateByUrl(url);
    //   }
    // } else {
    //   console.log('NAO POSSUI VERSAO');
    //   this.setCookieVersionSystem();
    // }

    console.log(new Date().toString().slice(16, 25) + '> VERSION: ' + this.getVersionSystem() + '\n ');
    this.writeLog('CONFIG SERVICE > ' + this.LOGIN_TYPE_ENABLED);
    this.getWebfeedertUrlSocket();
  }

  getVersionSystem() {
    return environment.version;
  }

  getAdapterOnlyBase() {
    return this._configurationService.getConfiguration('WEBFEEDER_REST_API_ADAPTER_WSO2', 'API_URLS');
  }

  getWebfeedertUrlSocket() {
    // LOGIN O & LOGIN S
    if (
      this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginO ||
      this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS ||
      this.getLoginTypeEnabled() ===  Constants.LOGIN_TYPE.LoginIAM
    ) {
      const broker = this.getConfigMultibroker();
      this._urlApiSocket = this.isMultiBroker() && broker ? broker.usersBrokerService :
        this.isMultiBroker() && !broker ? null : environment.WEBFEEDER.URL_WEB_FEEDER_FACADE;
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) { // WSO2
      this._urlApiSocket = environment.WEBFEEDER.URL_WEB_FEEDER_WSO2;
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginIAM) { // IAM
      this._urlApiSocket = environment.WEBFEEDER.URL_WEB_FEEDER_WSO2;
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA) { // ADAPTER
      this._urlApiSocket = environment.WEBFEEDER.URL_WEB_FEEDER_ADAPTER;
    } else {
      this.redirectExpireSession();
    }
    this.writeLog('CONFIG SERVICE > _urlApiSocket(): ' + this._urlApiSocket);
  }

  getApiWebFeederRest(): string {
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA) { // ADAPTER
      return this._configurationService.getEndPoint('WEBFEEDER_REST_API_ADAPTER_WSO2', 'WEBFEEDER_ADAPTER');
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginO || this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS) { // LOGIN O & LOGIN S
      const broker = this.getConfigMultibroker();
      return this.isMultiBroker() && broker ? broker.usersBrokerFaced : this.isMultiBroker() && !broker ? null :
        this._configurationService.getConfiguration('WEBFEEDER_REST_API_FACADE', 'API_URLS');
    } else if (
      this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW ||
      this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginIAM
    ) { // WSO2
      return this._configurationService.getEndPoint('WEBFEEDER_REST_API_WSO2', 'WEBFEEDER_WSO2');
    }
    return ''
  }

  getUrlWebSocketWebFeeder(numberReconect: number, graphic?: boolean, customToken?: string): string {

    let queryToken = '';
    let tokenWebFeeder;
    if (customToken) {
      tokenWebFeeder = customToken;
    } else {
      tokenWebFeeder = graphic ? this.getTokenGraphic() : this.getToken();
    }
    if (tokenWebFeeder !== undefined && tokenWebFeeder !== null && tokenWebFeeder !== 'null' && tokenWebFeeder !== '') {
      if (
        !graphic &&
        (
          this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW ||
          this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA
        )) {
        queryToken = '?token=' + tokenWebFeeder;
      } else {
        queryToken = '?reconnect=' + tokenWebFeeder;
      }
    }
    this.writeLog(this._urlApiSocket + queryToken);
    return this._urlApiSocket + queryToken;
  }

  getTokenGraphic() {
    let value = window.sessionStorage.getItem(Constants.COOKIE_TOKEN_WEBFEEDER_GRAPHIC);
    if (AppUtils.getPageByName('/worksheet', window.location.href)
      || AppUtils.getPageByName('/timestrades', window.location.href)
      || AppUtils.getPageByName('/asset-summary', window.location.href)
      || AppUtils.getPageByName('/book', window.location.href)
      || AppUtils.getPageByName('/volume-at-price', window.location.href)
      || AppUtils.getPageByName('/chart', window.location.href)
      || AppUtils.getPageByName('/billet-quick', window.location.href)
      || AppUtils.getPageByName('/billet-root', window.location.href)
      || AppUtils.getPageByName('/billet-wks', window.location.href)
      || AppUtils.getPageByName('/news-wks', window.location.href)
      || AppUtils.getPageByName('/position-day', window.location.href)
      || AppUtils.getPageByName('/position-balance-wks', window.location.href)
      || AppUtils.getPageByName('/order-wks', window.location.href)
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      if(urlParams.get('token')){
        value = urlParams.get('token');
      }
    }
    return value;
  }

  getSaveChartUrl() {
    return this._configurationService.getConfiguration('SAVE_CHART_API', 'API_URLS');
  }

  getUserApiUrl() {
    return this._configurationService.getConfiguration('USER_API', 'API_URLS');
  }

  getUserStore() {
    return this._configurationService.getConfiguration('STORE_URL', 'API_URLS');
  }

  // Api to save HB workspace
  getApiWorkspace(): string {
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA) {
      return this._configurationService.getConfiguration('WORKSPACE_REST_API_ADAPTER', 'API_URLS');
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS || this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginO) {
      return this._configurationService.getConfiguration('WORKSPACE_REST_API_FACADE', 'API_URLS');
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) {
      return this._configurationService.getConfiguration('WORKSPACE_REST_API_WSO2', 'API_URLS');
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginIAM) {
      return this._configurationService.getConfiguration('WORKSPACE_REST_API_WSO2', 'API_URLS');
    }
    return ''
  }

  getUserWorkspacesPreDefineds() {
    return this.WORKSPACE_PD_API_USER_PERFIL;
  }

  // NODE API to return data from candle to TrandingView
  getApiNodeCandleRequest(): string {
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA) { // ADAPTER
      return this._configurationService.getEndPoint('WEBFEEDER_REST_API_ADAPTER_WSO2', 'TRADINGVIEW_ADAPTER');
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS
      || this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginO) { // LOGIN O & LOGIN S
      if (this.isMultiBroker()) {
        const broker = this.getConfigMultibroker();
        if (broker) {
          this._urlApiSocket = broker.usersBrokerService;
          return broker.usersBrokerFaced;
        }
      }
      return this._configurationService.getConfiguration('WEBFEEDER_REST_API_FACADE', 'API_URLS');
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) { // WSO2
      return this._configurationService.getEndPoint('WEBFEEDER_REST_API_WSO2', 'TRADINGVIEW_WSO2');
    }
    return ''
  }

  getUrlApiFacade(isValidToken?, forceDefaultUrl?) {
    if (forceDefaultUrl || (isValidToken && !this.isAuthenticationBroker())) {
      return this._configurationService.getConfiguration('WEBFEEDER_REST_API_FACADE', 'API_URLS');
    } else {
      return this.getApiWebFeederRest();
    }
  }

  get CEDRO_ACCOUNT_API(): string {
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) { // WSO2
      return this._configurationService.getUrl('CEDRO_ACCOUNT_API_WSO2', 'API_URLS');
    }
    return ''
  }

  // WSO2
  get USER_IDENTITY_API(): string {
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) { // WSO2
      return this._configurationService.getEndPoint('WEBFEEDER_REST_API_WSO2', 'USER_IDENTITY_WSO2');
    }
    return ''
  }

  getApiWebFeederRestSuitabilityWSO2(): string {
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA) { // ADAPTER
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS
      || this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginO) { // LOGIN O & LOGIN S
      if (this.isMultiBroker()) {
        const broker = this.getConfigMultibroker();
        if (broker) {
          this._urlApiSocket = broker.usersBrokerService;
          return broker.usersBrokerFaced;
        }
      }
      return this._configurationService.getConfiguration('WEBFEEDER_REST_API_FACADE', 'API_URLS');
    } else if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) { // WSO2
      if (environment.SUITABILITY_OMS) {
        return this._configurationService.getEndPoint('WEBFEEDER_REST_API_WSO2', 'PORTAL_BUSINESS_WSO2');
      } else {
        return this._configurationService.getEndPoint('WEBFEEDER_REST_API_WSO2', 'REGISTRATION_SYSTEM_SUITABILITY');
      }
    }
    return ''
  }

  getApiWebFeederRestAuthAdapter(): string {
    return this._configurationService.getConfiguration('WEBFEEDER_REST_API_ADAPTER_AUTH', 'API_URLS');
  }

  getEletronicSignatureURL(): string {
    return this._configurationService.getConfiguration('ELETRONIC_SIGNATURE_API_ADAPTER', 'API_URLS');
  }

  getDepositEmailApi() {
    const typeTemp = this.getLoginTypeEnabled();
    if (typeTemp === Constants.LOGIN_TYPE.LoginS || typeTemp === Constants.LOGIN_TYPE.LoginO) {
      return this._configurationService.getConfiguration('DEPOSIT_EMAIL_REST_API_FACADE', 'API_URLS');
    } else if (typeTemp === Constants.LOGIN_TYPE.LoginW || typeTemp === Constants.LOGIN_TYPE.LoginIAM) {
      return this._configurationService.getConfiguration('DEPOSIT_EMAIL_REST_API_WSO2', 'API_URLS');
    } else if (typeTemp === Constants.LOGIN_TYPE.LoginA) {
      return this._configurationService.getConfiguration('DEPOSIT_EMAIL_REST_API_ADAPTER', 'API_URLS');
    }
  }

  getTermSuitabilityURL(): string {
    return this._configurationService.getConfiguration('TERM_SUITABILITY_API_ADAPTER', 'API_URLS');
  }

  getViaCepUrl() {
    return this._configurationService.getConfiguration('ADDRESS_VIA_CEP_API', 'API_URLS');
  }

  getYouTubeLiveApi(): string {
    return this._configurationService.getConfiguration('YOUTUBE_LIVE', 'API_URLS') + '/' + this._youtubeApiVrs + '/';
  }

  getApiUrlBusenessWSO2() {
    return this._configurationService.getEndPoint('WEBFEEDER_REST_API_WSO2', 'PORTAL_BUSINESS_WSO2');
  }

  setTokenApi(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_WEBAPI, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_TOKEN_WEBAPI, value);
    }
  }

  getTokenApi() {
    return window.sessionStorage.getItem(Constants.COOKIE_TOKEN_WEBAPI);
  }

  setToken(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_WEBFEEDER, value);
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) {
      this._transitionService.setKeyValue(Constants.COOKIE_TOKEN_WEBFEEDER, value);
    }
  }

  setTokenWS(value: string) {
    if (value !== null && value !== '') {
      window.sessionStorage.setItem(Constants.COOKIE_HOUR_TOKEN_WS, value);
      window.sessionStorage.setItem(Constants.COOKIE_TOKEN_WEBFEEDER, value);
      if (this.isLoginTypeWSO2()) {
        this._transitionService.setKeyValue(Constants.COOKIE_TOKEN_WEBFEEDER, value);
      }
    } else {
      AppUtils.deleteCookie(Constants.COOKIE_HOUR_TOKEN_WS);
      AppUtils.deleteCookie(Constants.COOKIE_TOKEN_WEBFEEDER);
      if (this.isLoginTypeWSO2()) {
        this._transitionService.removeKeyValue(Constants.COOKIE_TOKEN_WEBFEEDER);
      }
    }
  }

  getToken() {

    let value = '';
    if (this.isMultiBroker() && this.getTokenNegotiation()) {
      value = this.getTokenNegotiation();
    } else {
      value = window.sessionStorage.getItem(Constants.COOKIE_TOKEN_WEBFEEDER);
    }
    if (AppUtils.getPageByName('/worksheet', window.location.href)
      || AppUtils.getPageByName('/timestrades', window.location.href)
      || AppUtils.getPageByName('/asset-summary', window.location.href)
      || AppUtils.getPageByName('/book', window.location.href)
      || AppUtils.getPageByName('/volume-at-price', window.location.href)
      || AppUtils.getPageByName('/chart', window.location.href)
      || AppUtils.getPageByName('/billet-quick', window.localStorage['href'])
      || AppUtils.getPageByName('/billet-root', window.location.href)
      || AppUtils.getPageByName('/billet-wks', window.location.href)
      || AppUtils.getPageByName('/news-wks', window.location.href)
      || AppUtils.getPageByName('/position-day', window.location.href)
      || AppUtils.getPageByName('/position-balance-wks', window.location.href)
      || AppUtils.getPageByName('/order-wks', window.location.href)
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      value = urlParams.get('token');
    }
    // this.writeLog('\nCONFIG SERVICE > getToken(): ' + value);
    return value;
  }

  getTokenNegotiation() {
    let value = window.sessionStorage.getItem(Constants.COOKIE_TOKEN_WEBFEEDER_NEGOTIATION);
    if (AppUtils.getPageByName('/worksheet', window.location.href)
      || AppUtils.getPageByName('/timestrades', window.location.href)
      || AppUtils.getPageByName('/asset-summary', window.location.href)
      || AppUtils.getPageByName('/book', window.location.href)
      || AppUtils.getPageByName('/volume-at-price', window.location.href)
      || AppUtils.getPageByName('/chart', window.location.href)
      || AppUtils.getPageByName('/billet-quick', window.location.href)
      || AppUtils.getPageByName('/billet-root', window.location.href)
      || AppUtils.getPageByName('/billet-wks', window.location.href)
      || AppUtils.getPageByName('/news-wks', window.location.href)
      || AppUtils.getPageByName('/position-day', window.location.href)
      || AppUtils.getPageByName('/position-balance-wks', window.location.href)
      || AppUtils.getPageByName('/order-wks', window.location.href)
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      value = urlParams.get('token');
    }
    return value;
  }

  setTokenGraphic(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_WEBFEEDER_GRAPHIC, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_TOKEN_WEBFEEDER_GRAPHIC, value);
    }
  }

  setTimerTokenExpiration(value) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_TIMER_EXPIRATION, value);
  }

  getTimerTokenExpiration() {
    return window.sessionStorage.getItem(Constants.COOKIE_TOKEN_TIMER_EXPIRATION);
  }

  setTokenTp(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_TP, value);
  }

  setTokenLastRefreshed(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_LAST_REFRESHED, value);
  }

  getTokenLastRefreshed() {
    return window.sessionStorage.getItem(Constants.COOKIE_TOKEN_LAST_REFRESHED);
  }

  setRefreshSnapDaily(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_REFRESH_PAGE, value);
  }

  getRefreshPage() {
    return window.sessionStorage.getItem(Constants.COOKIE_REFRESH_PAGE);
  }

  setAfterLoginMessage(value: string) {
    window.sessionStorage.setItem(Constants.SESSION_STORAGE_AFTER_LOGIN_MESSAGE, value);
  }

  getAfterLoginMessage() {
    return window.sessionStorage.getItem(Constants.SESSION_STORAGE_AFTER_LOGIN_MESSAGE);
  }

  getAfterLoginMessageContent() {
    const mesageConfig = this._configurationService.getConfiguration('AFTER_LOGIN_MESSAGE');

    const title = mesageConfig && mesageConfig.TITLE ? mesageConfig.TITLE : null;
    const content = mesageConfig && mesageConfig.CONTENT ? mesageConfig.CONTENT : null;
    const effectiveDate = mesageConfig && mesageConfig.EFFECTIVE_DATE ? mesageConfig.EFFECTIVE_DATE : null;

    return { title, content, effectiveDate };
  }

  setFirstLoginModalNotification(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_FIRST_MODAL_NOTIFICATION, value);
  }

  getFirstLoginModalNotification() {
    return window.sessionStorage.getItem(Constants.COOKIE_FIRST_MODAL_NOTIFICATION);
  }

  setTokenExpiration(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_EXPIRATION, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_TOKEN_EXPIRATION, value);
    }
  }

  getTokenExpiration() {
    return window.sessionStorage.getItem(Constants.COOKIE_TOKEN_EXPIRATION);
  }

  setGuidUser(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_GUID_USER, value);
  }

  getGuidUser() {
    return window.sessionStorage.getItem(Constants.COOKIE_GUID_USER);
  }

  setHba(value: string, index: string) {
    Cookie.set(Constants.COOKIE_HB_ABA, value, 0.5, '/', window.location.hostname);
  }

  getHba() {
    return Cookie.get(Constants.COOKIE_HB_ABA);
  }

  deleteHba() {
    Cookie.delete(Constants.COOKIE_HB_ABA);
  }

  getBrokerToken() {
    return window.sessionStorage.getItem(Constants.COOKIE_TOKEN_BROKER_WEBFEEDER);
  }

  setTokenNegotiation(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_WEBFEEDER_NEGOTIATION, value);
  }

  getCookieUserLoginMultiBroker() {
    const user = Cookie.get(Constants.COOKIE_HB_USER_MULTI + (this.getUserMarketData() ? this.getUserMarketData().login.toUpperCase() : null));
    return user ? JSON.parse(user) : null;
  }

  setCookieUserLoginMultiBroker(broker: string, username: string) {
    const userCookie = this.getCookieUserLoginMultiBroker();
    const user = userCookie ? userCookie : { login: this.getHbAccount().toUpperCase(), brokers: [] };
    const hasIndexUserBrokerCookie = user.brokers.findIndex(x => x.broker === broker);
    if (!userCookie) {
      window.sessionStorage.setItem(Constants.COOKIE_HB_USER_LOGIN_MARKET, this.getHbAccount().toUpperCase());
    }
    if (hasIndexUserBrokerCookie >= 0) {
      user.brokers[hasIndexUserBrokerCookie].username = username;
    } else {
      user.brokers.push({ broker: broker, username: username });
    }
    Cookie.set(Constants.COOKIE_HB_USER_MULTI + window.sessionStorage.getItem(Constants.COOKIE_HB_USER_LOGIN_MARKET), JSON.stringify(user), 0.5, '/', window.location.hostname);
  }

  deleteCookieUserLoginMultiBroker(user) {

  }

  setBrokerAccount(value: string, type: string) {
    if (type) {
      window.sessionStorage.setItem(Constants.COOKIE_HB_LOGIN_TYPE, type);
    }
    if (value && value !== '[]') {
      window.sessionStorage.setItem(Constants.COOKIE_HB_BROKER_ACCOUNT, value);
      if (environment.loginDuplicateNegotiation) {
        this._negotiationAccountUser.next(value);
      }
    }
    if (this.isLoginTypeWSO2()) {
      if (value) {
        this._transitionService.setKeyValue(Constants.COOKIE_HB_BROKER_ACCOUNT, value);
      }
      if (type) {
        this._transitionService.setKeyValue(Constants.COOKIE_HB_LOGIN_TYPE, type);
      }
    }
  }

  setBrokerConnected(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_BROKER_CONNECTED, value ? value.toUpperCase() : null);
  }

  getBrokerConnected() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_BROKER_CONNECTED);
  }

  setSymbolInformation(newValue: any) {
    let arrayToSave = [];
    const chartInformation = this.getSymbolInformation();
    const chartInfoParsed = JSON.parse(chartInformation);
    if (chartInfoParsed) {
      arrayToSave = chartInfoParsed.filter((x: any) => x.chartId !== newValue.chartId) ? chartInfoParsed.filter((x: any) => x.chartId !== newValue.chartId) : [];
    }
    arrayToSave.push(newValue);
    window.sessionStorage.setItem(Constants.SESSION_STORAGE_SYMBOL_INFORMATION, arrayToSave.length > 0 ? JSON.stringify(arrayToSave) : null);
  }

  getSymbolInformation() {
    return window.sessionStorage.getItem(Constants.SESSION_STORAGE_SYMBOL_INFORMATION);
  }

  deleteSymbolInformation(chartIdToDelete: string) {
    let arrayToSave = [];
    const chartInformation = this.getSymbolInformation();
    if (chartInformation && typeof (chartInformation) === 'string') {
      const chartInfoParsed = JSON.parse(chartInformation);
      if (chartInfoParsed) {
        arrayToSave = chartInfoParsed.filter((x: any) => x.chartId !== chartIdToDelete) ? chartInfoParsed.filter((x: any) => x.chartId !== chartIdToDelete) : [];
        if (arrayToSave.length > 0) {
          window.sessionStorage.setItem(Constants.SESSION_STORAGE_SYMBOL_INFORMATION, JSON.stringify(arrayToSave));
        } else {
          window.sessionStorage.removeItem(Constants.SESSION_STORAGE_SYMBOL_INFORMATION);
        }
      } else {
        window.sessionStorage.removeItem(Constants.SESSION_STORAGE_SYMBOL_INFORMATION);
      }
    } else {
      window.sessionStorage.removeItem(Constants.SESSION_STORAGE_SYMBOL_INFORMATION);
    }
  }

  deleteAllSymbolInformation() {
    window.sessionStorage.removeItem(Constants.SESSION_STORAGE_SYMBOL_INFORMATION);
  }

  notifyDoubleChart() {
    this._notificationService.error('Erro', Constants.WORKSPACE_MSG015);
  }

  isLoginTypeWSO2() {
    return Constants.LOGIN_TYPE.LoginW === this.getLoginTypeEnabled() ? true : false;
  }

  isLoginTypeAdapter() {
    return Constants.LOGIN_TYPE.LoginA === this.getLoginTypeEnabled() ? true : false;
  }

  isLoginTypeIAM() {
    return Constants.LOGIN_TYPE.LoginIAM === this.getLoginTypeEnabled() ? true : false;
  }

  isMultiBroker() {
    return this.getConfigMultibroker() ? true : false;
  }

  setUserIdentifier(value) {
    window.sessionStorage.setItem(Constants.COOKIE_USER_IDENTIFIER, value);
  }

  getUserIdentifier() {
    return window.sessionStorage.getItem(Constants.COOKIE_USER_IDENTIFIER);
  }

  isAuthenticationBroker() {
    return this.getBrokerAccount() ? true : false;
  }

  isLoginMarketData() {
    return Number(this.getBrokerAccountType()) === ConnectTypeUperEnum.HB_TYPE_MARKET_DATA ? true : false;
  }

  isAuthenticadSystem() {
    let tokenApi = this.getTokenApi();
    let loginEnabled:any = this.getLoginTypeEnabled();
    let guidUser = this.getGuidUser();
    if (
        !!tokenApi &&
        (
          [Constants.LOGIN_TYPE.LoginW,Constants.LOGIN_TYPE.LoginA,Constants.LOGIN_TYPE.LoginIAM].includes(loginEnabled) ||
          (!!tokenApi && !!guidUser)
        )
      ) {
      return true;
    }
    return false;
  }

  isTypeBilletStopSimultaneousOrOco() {
    return this.getConfigWhitelabel().billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.SIMULTANEOUS ? true : false;
  }

  isUserAssessorLogged() {
    const isAssessor = this.getUserLoginType();
    return Number(isAssessor) === Profile.Assessor ? true : false;
  }

  setAssessorId(assessorId) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_ASSESSOR_ID, assessorId);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_HB_ASSESSOR_ID, assessorId);
    }
  }

  getAssessorId() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_ASSESSOR_ID);
  }

  getUserLoginType() {
    return window.sessionStorage.getItem(Constants.COOKIE_USER_LOGIN_TYPE);
  }

  getLoginTypeEnabled() {
    return this.LOGIN_TYPE_ENABLED;
  }

  setHbLoginTypeEnable(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_LOGIN_TYPE_ENABLED, value);
  }

  getWhiteLabel() {
    return environment.WHITELABEL;
  }

  getConfigWhitelabel() {
    return Constants.WHITELABEL.find(x => x.system.cod === this.getWhiteLabel());
  }

  getBrokerAccountType() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_LOGIN_TYPE);
  }

  getBroker() {
    if (this.isMultiBroker()) {
      const broker = this.getConfigMultibroker();
      if (broker) {
        return broker.usersBrokerName;
      }
    }
    return environment.BROKER;
  }

  registerGoToIdentity() {
    return this._configurationService.getConfiguration('REGISTER_IDENTITY', 'SYSTEM_VARIABLES');
  }

  getGoogleTagManagerID(): string {
    return this._configurationService.getConfiguration('GOOGLE_TAG_MANAGER_ID', 'SYSTEM_VARIABLES');
  }

  getPrivallyPid() {
    return this._configurationService.getConfiguration('PRIVALLY_PID_ID', 'SYSTEM_VARIABLES');
  }

  getNewsListAgency() {
    const listAgency = this._configurationService.getConfiguration('NEWS_AGENCY', 'SYSTEM_VARIABLES');
    return listAgency ? JSON.parse(listAgency) : null;
  }

  getApiWebFeederRestFacadeWSO2(): string {
    return this._configurationService.getEndPoint('WEBFEEDER_REST_API_WSO2', 'PORTAL_FACADE_WSO2');
  }

  getCookieWorkspace() {
    return window.sessionStorage.getItem(Constants.COOKIE_WORKSPACE);
  }

  setCookieWorkspace(wks) {
    window.sessionStorage.setItem(Constants.COOKIE_WORKSPACE, wks);
  }

  setBrokerAccountList(value) {
    const json = value ? JSON.stringify(value) : null;
    if (json) {
      window.sessionStorage.setItem(Constants.COOKIE_HB_BROKER_ACCOUNT_LIST, json);
      if (this.isLoginTypeWSO2()) {
        this._transitionService.setKeyValue(Constants.COOKIE_HB_BROKER_ACCOUNT_LIST, json);
      }
    }
  }

  setBrokerAccountSelected(value: string, notifyChange?: boolean) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_BROKER_ACCOUNT_SELECTED, value);
    if (notifyChange) {
      this._changeAccountBillet.next(value);
    }
  }

  setBrokerAccountSelectedTransition(value: string) {
    this._transitionService.setKeyValue(Constants.COOKIE_HB_BROKER_ACCOUNT_SELECTED, value);
  }

  deleteBrokerAccountSelectedTransition() {
    window.sessionStorage.removeItem(Constants.COOKIE_HB_BROKER_ACCOUNT_SELECTED);
  }

  setAdisorGestorCanAcceptTerm(value: boolean) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_ADVISOR_GESTOR_CAN_ACCEPT_TERM, value ? value.toString() : null);
  }

  getAdisorGestorCanAcceptTerm() {
    const value = window.sessionStorage.getItem(Constants.COOKIE_HB_ADVISOR_GESTOR_CAN_ACCEPT_TERM);
    return value === 'true' ? true : false;
  }

  getBrokerAccountSelected() {
    const account = window.sessionStorage.getItem(Constants.COOKIE_HB_BROKER_ACCOUNT_SELECTED);
    return account !== 'undefined' && account !== null && account !== 'null' ? account : null;
  }

  setAssessorClientSelected(value) {
    const listClients = value ? JSON.stringify(value) : null;
    window.sessionStorage.setItem(Constants.COOKIE_ASSESSOR_CLIENT_SELECTED, listClients);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_ASSESSOR_CLIENT_SELECTED, listClients);
    }
  }

  getAssessorClientSelected() {
    const listClients = window.sessionStorage.getItem(Constants.COOKIE_ASSESSOR_CLIENT_SELECTED);
    if (listClients) {
      return JSON.parse(listClients);
    }
    return null;
  }

  setAssessorListClients(value) {
    this.AssessorListClient = value ? JSON.stringify(value) : null;
    this._transitionService.removeKeyValue(Constants.COOKIE_ASSESSOR_LIST_CLIENT);
  }

  getAssessorListClients() {
    return this.AssessorListClient ? JSON.parse(this.AssessorListClient) : null;
  }

  getInfoUserLogged() {
    const user = window.sessionStorage.getItem(Constants.COOKIE_HB_BROKER_USER_INFO_SELECTED);
    return user ? JSON.parse(user) : null;
  }

  setInfoUserLogged(value) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_BROKER_USER_INFO_SELECTED, JSON.stringify(value));
  }

  deleteAllCookie() {
    return window.sessionStorage.clear();
  }

  setConfigMultibroker(value) {
    if (value) {
      this._urlApiSocket = value.usersBrokerService;
      window.sessionStorage.setItem(Constants.COOKIE_HB_CONFIG_MULTI_BROKER, JSON.stringify(value));
    }
  }

  getConfigMultibroker() {
    return JSON.parse(window.sessionStorage.getItem(Constants.COOKIE_HB_CONFIG_MULTI_BROKER));
  }

  deleteConfigMultibroker() {
    this.getWebfeedertUrlSocket();
    window.sessionStorage.removeItem(Constants.COOKIE_HB_CONFIG_MULTI_BROKER);
  }

  setFavoriteThemeUser(value) {
    value = value ? value.toString() : null;
    Cookie.set(Constants.LAYOUT_THEME_DARK, value, null, '/');
    window.sessionStorage.setItem(Constants.LAYOUT_THEME_DARK, value);
  }

  getFavoriteThemeUser() {
    const cookieTheme = Cookie.get(Constants.LAYOUT_THEME_DARK);
    const sessionTheme = window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK);
    if (sessionTheme === null && cookieTheme === null) {
      const whiteLabelConfig = this.getConfigWhitelabel();
      return whiteLabelConfig.system.isThemeDarkDefault;
    } else if (cookieTheme === 'true' || sessionTheme === 'true') {
      return true;
    } else {
      return false;
    }
  }

  deleteFavoriteThemeUser() {
    return window.sessionStorage.removeItem(Constants.LAYOUT_THEME_DARK);
  }

  setShowStatusOms(value) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_SHOW_STATUS_OMS, JSON.stringify(value));
  }

  getBrokerAccountList() {
    const res = window.sessionStorage.getItem(Constants.COOKIE_HB_BROKER_ACCOUNT_LIST);
    return res ? JSON.parse(res) : null;
  }

  getBrokerAccount() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_BROKER_ACCOUNT);
  }

  getShowStatusOms() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_SHOW_STATUS_OMS) === 'true' ? true : false;
  }

  setHbCurrentUser(user) {
    const json = typeof (user) === 'string' ? user : JSON.stringify(user);
    window.sessionStorage.setItem(Constants.COOKIE_HB_CURRENTUSER, json);
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) {
      this._transitionService.setKeyValue(Constants.COOKIE_HB_CURRENTUSER, json);
    }
  }

  getHbCurrentUser() {
    const userLogged = window.sessionStorage.getItem(Constants.COOKIE_HB_CURRENTUSER);
    return userLogged ? JSON.parse(userLogged) : null;
  }

  deleteHbCurrentUser() {
    AppUtils.deleteCookie(Constants.COOKIE_HB_CURRENTUSER);
  }

  getShowExpandCard(component: string) {
    if (component === Constants.WINDOW_NAME_QUOTE_CHART) {
      return true;
    }
    return environment.showExpandCard;
  }

  setEletronicSignatureType(value) {
    if (value) {
      window.sessionStorage.setItem(Constants.SIGNATURE_ELETRONIC_TYPE, JSON.stringify(value));
    }
  }

  getEletronicSignatureType() {
    const signatureTemp = window.sessionStorage.getItem(Constants.SIGNATURE_ELETRONIC_TYPE);
    if (signatureTemp) {
      return JSON.parse(signatureTemp);
    }
  }

  deleteEletronicSignatureType() {
    window.sessionStorage.removeItem(Constants.SIGNATURE_ELETRONIC_TYPE);
  }

  getPressureBarColor(side: SideEnum) {
    const theme = window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK) === 'true' ? 'dark' : 'light';
    const bodyStyles = window.getComputedStyle(document.body);
    return bodyStyles.getPropertyValue(`--color-${theme}-${side.toLowerCase()}`);
  }

  getExtensionLogo() {
    const bodyStyles = window.getComputedStyle(document.body);
    return bodyStyles.getPropertyValue('--extension-logo');
  }

  getHbSignature() {
    const value = window.sessionStorage.getItem(Constants.SIGNATURE_ELETRONIC);
    return value ? JSON.parse(value) : null;
  }

  setHbSignature(value: string) {
    window.sessionStorage.setItem(Constants.SIGNATURE_ELETRONIC, JSON.stringify(value));
  }

  deleteHbSignature() {
    window.sessionStorage.removeItem(Constants.SIGNATURE_ELETRONIC);
  }

  getOrderHistoryFilterRange(): number {
    return this._configurationService.getConfiguration('ORDER_HISTORY_FILTER_RANGE', 'SYSTEM_VARIABLES');
  }

  getExtractFinancialFilterRange(): number {
    return this._configurationService.getConfiguration('EXTRACT_FINANCIAL_FILTER_RANGE', 'SYSTEM_VARIABLES');
  }

  getModalNewsFilterRange(): number {
    return this._configurationService.getConfiguration('MODAL_NEWS_FILTER_RANGE', 'SYSTEM_VARIABLES');
  }

  getOrderBilletBrokerageValue() {
    return this._configurationService.getConfiguration('BROKERAGE_VALUE', 'SYSTEM_VARIABLES');
  }

  getUserSystemLogged() {
    if (this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW && !this.isUserAssessorLogged()) { // WSO2
      return window.sessionStorage.getItem(Constants.COOKIE_HB_ACCOUNT_NAME);
    } else {
      return window.sessionStorage.getItem(Constants.COOKIE_SYSTEM_ACCOUNT_NAME);
    }
  }

  getUserAccountLogged() {
    if ((this.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginO)) {
      return this.getBrokerAccount();
    }
    return window.sessionStorage.getItem(Constants.COOKIE_SYSTEM_ACCOUNT_NAME);
  }

  getConfigBilletClose() {
    if (window.sessionStorage.getItem(Constants.COOKIE_BILLET_CLOSED_MODAL)) {
      return JSON.parse(window.sessionStorage.getItem(Constants.COOKIE_BILLET_CLOSED_MODAL));
    }
  }

  setConfigBilletClose(model: SimpleOrder) {
    model.maxfloor = 0;
    window.sessionStorage.setItem(Constants.COOKIE_BILLET_CLOSED_MODAL, JSON.stringify(model));
  }

  deleteConfigBilletClose() {
    window.sessionStorage.removeItem(Constants.COOKIE_BILLET_CLOSED_MODAL);
  }

  setTokenRefreshApi(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_TOKEN_REFRESH_WEBAPI, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_TOKEN_REFRESH_WEBAPI, value);
    }
  }

  getTokenRefreshApi() {
    return window.sessionStorage.getItem(Constants.COOKIE_TOKEN_REFRESH_WEBAPI);
  }

  setScope(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_SCOPE, value);
  }

  setIsAssessor(type: number) {
    if (type === Profile.Client) {
      this._transitionService.setKeyValue(Constants.COOKIE_IS_ASSESSOR, false);
    } else {
      this._transitionService.setKeyValue(Constants.COOKIE_IS_ASSESSOR, true);
    }
  }

  setUserLoginType(type) {
    const typeUser = type === Profile.Assessor ? Profile.Assessor.toString() : Profile.Client.toString();
    window.sessionStorage.setItem(Constants.COOKIE_USER_LOGIN_TYPE, typeUser);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_USER_LOGIN_TYPE, typeUser);
    }
  }

  setHbUserId(userId) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_USER_ID, userId);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_HB_USER_ID, userId);
    }
  }

  setHbAccount(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_ACCOUNT, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_HB_ACCOUNT, value);
    }
  }

  getHbAccount() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_ACCOUNT);
  }

  getHbUserId() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_USER_ID);
  }

  setHbAccountId(accountId) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_ACCOUNT_ID, accountId);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_HB_ACCOUNT_ID, accountId);
    }
  }

  getHbAccountId() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_ACCOUNT_ID);
  }

  setHbAccountName(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_ACCOUNT_NAME, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_HB_ACCOUNT_NAME, value);
    }
  }

  setHbEmail(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_HB_ACCOUNT_EMAIL, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_HB_ACCOUNT_EMAIL, value);
    }
  }

  getHbEmail() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_ACCOUNT_EMAIL);
  }

  setUserSystemLogged(userlogged) {
    window.sessionStorage.setItem(Constants.COOKIE_SYSTEM_ACCOUNT_NAME, userlogged);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_SYSTEM_ACCOUNT_NAME, userlogged);
    }
  }

  setProfileName(value: string) {
    value = value ? value : 'NÃO ENCONTRADO';
    window.sessionStorage.setItem(Constants.COOKIE_CLIENT_PROFILE_NAME, value);
    if (this.isLoginTypeWSO2()) {
      this._transitionService.setKeyValue(Constants.COOKIE_CLIENT_PROFILE_NAME, value);
    }
  }

  getProfileName() {
    return window.sessionStorage.getItem(Constants.COOKIE_CLIENT_PROFILE_NAME);
  }

  closeBillet(close: boolean) {
    if (close) {
      this._modalBuySellClosed.next(true);
      this._modalBuySellClosed.next(false);
    }
  }


  deleteCookie() {
    window.sessionStorage.clear();
    if (this.isLoginTypeWSO2()) {
      this._transitionService.clear();
    }
  }
  deleteLocalstore() {
    window.localStorage.clear();
    if (this.isLoginTypeWSO2()) {
      this._transitionService.clear();
    }
  }

  deleteHbBrokerUser() {
    console.trace('deleteHbBrokerUser')
    AppUtils.deleteCookie(Constants.COOKIE_HB_LOGIN_TYPE);
    AppUtils.deleteCookie(Constants.COOKIE_HB_LOGIN_TYPE_ENABLED);
    AppUtils.deleteCookie(Constants.COOKIE_TOKEN_WEBFEEDER_NEGOTIATION);
    AppUtils.deleteCookie(Constants.COOKIE_TOKEN_REFRESH_WEBAPI);
    AppUtils.deleteCookie(Constants.COOKIE_HB_BROKER_ACCOUNT_SELECTED);
    AppUtils.deleteCookie(Constants.COOKIE_HB_BROKER_ACCOUNT);
    AppUtils.deleteCookie(Constants.COOKIE_HB_ACCOUNT_NAME);
    AppUtils.deleteCookie(Constants.COOKIE_HB_ACCOUNT_EMAIL);
    AppUtils.deleteCookie(Constants.COOKIE_HB_ACCOUNT_ID);
    AppUtils.deleteCookie(Constants.COOKIE_CURRENT_BROKER);
    AppUtils.deleteCookie(Constants.COOKIE_TOKEN_BROKER_WEBFEEDER);
    AppUtils.deleteCookie(Constants.COOKIE_TOKEN_BROKER_EXPIRATION);
    this._changeAccountBillet.next('');
    if (this.isLoginTypeWSO2()) {
      this._transitionService.clear();
    }
  }

  REDIRECT_LOGOUT() {
    const url = this.getUrlRedirectLoginLogout(false);
    this._modalService.closeAll();
    this.deleteHbBrokerUser();
    this.deleteCookie();
    this.deleteLocalstore();
    this.deleteFavoriteThemeUser();
    if (!environment.isDev && (this.isLoginTypeWSO2() || this.isLoginTypeAdapter())) {
      window.location.href = url;
    } else {
      this._router.navigate([url]);
    }
  }

  REDIRECT_LOGIN() {
    const url = this.getUrlRedirectLoginLogout(true);
    this._modalService.closeAll();
    this.deleteHbBrokerUser();
    this.deleteCookie();
    this.deleteFavoriteThemeUser();
    if (!environment.isDev && (this.isLoginTypeWSO2() || this.isLoginTypeAdapter())) {
      window.location.href = url;
    } else {
      this._router.navigate([url]);
    }
  }

  redirectExpireSession(message?: string, subTitle?: string, service?: any, codKey?: any, icon?: any) {
    this._logSvc.error(`ExpireSession: ${JSON.stringify({ message, subTitle, service, codKey, icon })}`);
    const url = this.getUrlRedirectLoginLogout(false);
    this._notificationService.remove();
    this.deleteHbBrokerUser();
    this.deleteCookie();
    this.deleteFavoriteThemeUser();
    this._modalService.closeAll();
    message = message ? message : Constants.ERROR_EXPIRED_TITLE;
    const serviceTemp: any = DictionaryError.ERROR_DICTIONARY.find(x => x.cod === service || x.key === service);
    const codError = serviceTemp && serviceTemp.error && codKey ? serviceTemp.error.find(x => x.cod === codKey).desc_front : null;
    message = codError ? codError + ' - ' + message : message;
    subTitle = subTitle ? subTitle : Constants.ERROR_EXPIRED_TEXT;
    this._router.navigate(['error'], {
      queryParams: new ErrorMessage((icon ? icon : Constants.ERROR_DENIED_ICON), message, subTitle, Constants.ERROR_EXPIRED_BUTTON, url)
    });
  }

  getUrlRedirectLoginLogout(isLogin: boolean) {
    const urlEnv = this._configurationService.getUrl(isLogin ? 'REDIRECT_LOGIN' : 'REDIRECT_LOGOUT', 'API_URLS');
    const path = this.isLoginTypeWSO2() && this.isUserAssessorLogged() ? 'portal/assessor/login'
      : this.isLoginTypeWSO2() ? 'portal/client/login' : null;
    return urlEnv + (path ? '/' + path : '');
  }

  writeLog(msg, text?: string) {
    const account = this.getHbAccount() || this.getBrokerAccountSelected();
    const now = new Date().toString().slice(16, 25);
    if (typeof msg === 'string') {
      if (environment.showConsoleLog || environment.isDev ||
        (account && (account.toLowerCase() === 'vcrcad' || account.toLowerCase() === '9900044051'))) {
        console.log(now + '> ' + msg + '\n\n');
      }
    } else {
      if (environment.showConsoleLog || environment.isDev ||
        (account && (account.toLowerCase() === 'vcrcad' || account.toLowerCase() === '9900044051'))) {
        console.log(now + '> ' + text, msg);
        console.log('\n');
      }
    }
  }

  writeError(msg) {
    if (environment.showConsoleLog) {
      const now = new Date().toString().slice(16, 24);
      console.error(now + '> ' + msg);
    }
  }

  getDictionaryError() {
    return DictionaryError.ERROR_DICTIONARY;
  }

  getMenuConfig() {
    return Constants.MENU_SYSTEM_DEFAULT;
  }

  systemNotificationMessage(title, message, typeAlert) {
    switch (typeAlert) {
      case Constants.ALERT_TYPE.success:
        this._notificationService.success(title, message);
        break;
      case Constants.ALERT_TYPE.error:
        this._notificationService.error(title, message);
        break;
      case Constants.ALERT_TYPE.error_reject:
        this._notificationService.bare(title, message);
        break;
      case Constants.ALERT_TYPE.info:
        this._notificationService.info(title, message);
        break;
      case Constants.ALERT_TYPE.warn:
        this._notificationService.warn(title, message);
        break;
      default:
        this._notificationService.alert(title, message);
        break;
    }
  }

  setUserMarketData(login: string, password: string, tokenApi: string) {
    const user = AppUtils.encryptData({ login: login, password: password, tknApi: tokenApi }, Constants.COOKIE_ENCRYPT_SECRET_KEY);
    window.sessionStorage.setItem(Constants.COOKIE_LOGIN_MARKET_DATA, user);
  }

  getUserMarketData() {
    const wlConfig = this.getConfigWhitelabel();
    return wlConfig.system.isMultiBroker ? AppUtils.decryptData(window.sessionStorage.getItem(Constants.COOKIE_LOGIN_MARKET_DATA), Constants.COOKIE_ENCRYPT_SECRET_KEY) : null;
  }

  setHideMessageDisconectSocket(value: string) {
    window.sessionStorage.setItem(Constants.COOKIE_IS_LOGIN_MULTIBROKER, value);
  }

  getHideMessageDisconectSocket() {
    const value = window.sessionStorage.getItem(Constants.COOKIE_IS_LOGIN_MULTIBROKER);
    return value === 'true' ? true : false;
  }

  deleteHideMessageDisconectSocket() {
    window.sessionStorage.removeItem(Constants.COOKIE_IS_LOGIN_MULTIBROKER);
  }

  getStopValidUser() {
    const value = window.sessionStorage.getItem(Constants.COOKIE_STOP_VALID);
    return value === 'true' ? true : false;
  }

  setStopValidUser(value: boolean) {
    if (value) {
      window.sessionStorage.setItem(Constants.COOKIE_STOP_VALID, 'true');
    }
  }

  removeStopValidUser() {
    window.sessionStorage.removeItem(Constants.COOKIE_STOP_VALID);
  }

  getCookieConfigCards(componentName?: string) {
    let config = localStorage.getItem(Constants.COOKIE_CONFIG_CARDS_WKS);
    config = config ? JSON.parse(config) : null;
    return config && componentName ? config[componentName] : config;
  }

  setCookieConfigCards(componentName, configCards: ConfigCardsModel) {
    let config = this.getCookieConfigCards();
    if (!config) {
      config = {
        [Constants.WINDOW_NAME_BILLET_ROOT]: {},
        [Constants.WINDOW_NAME_BOOK]: [],
        [Constants.WINDOW_NAME_QUOTE_CHART]: [],
      };
    }
    if (componentName.includes(Constants.WINDOW_NAME_BILLET_ROOT)) {
      config[componentName] = {};
      config[componentName].billetRootTypeId = configCards.billetRootTypeId;
      config[componentName].billetRootShowHeaderFull = configCards.billetRootShowHeaderFull;
      config[componentName].billetRootHiddenConfirmation = configCards.billetRootHiddenConfirmation;
    } else if (componentName === Constants.WINDOW_NAME_BOOK) {
      const indexTemp = config[componentName] ? config[componentName].findIndex(x => x.bookIdComp === configCards.bookIdComp) : -1;
      if (indexTemp >= 0) {
        config[componentName][indexTemp].bookIdComp = configCards.bookIdComp;
        config[componentName][indexTemp].bookTabIndex = configCards.bookTabIndex;
      } else {
        config[componentName].push({ bookIdComp: configCards.bookIdComp, bookTabIndex: configCards.bookTabIndex });
      }
    } else if (componentName === Constants.WINDOW_NAME_QUOTE_CHART) {
      const indexTemp = config[componentName] ? config[componentName].findIndex(x => x.quoteChartId === configCards.quoteChartId) : -1;
      if (indexTemp >= 0) {
        config[componentName][indexTemp].quoteChartId = configCards.quoteChartId;
        config[componentName][indexTemp].quoteChartHiddenConfirmation = configCards.quoteChartHiddenConfirmation;
      } else {
        config[componentName].push({ quoteChartId: configCards.quoteChartId, quoteChartHiddenConfirmation: configCards.quoteChartHiddenConfirmation });
      }
    }
    localStorage.setItem(Constants.COOKIE_CONFIG_CARDS_WKS, JSON.stringify(config));
  }

  deleteCookieConfigCards(componentName: string, isBillet: boolean, itemId: number) {
    const config = this.getCookieConfigCards();
    if (componentName === Constants.WINDOW_NAME_BOOK && itemId !== null && itemId >= 0) {
      const indexTemp = config[componentName].findIndex(x => x.bookIdComp === itemId);
      if (indexTemp >= 0) {
        config[componentName].splice(indexTemp, 1);
      }
    } else if (componentName === Constants.WINDOW_NAME_QUOTE_CHART && itemId !== null && itemId >= 0) {
      const indexTemp = config[componentName].findIndex(x => x.quoteChartId === itemId);
      if (indexTemp >= 0) {
        config[componentName].splice(indexTemp, 1);
      }
    } else if (isBillet) {
      config[componentName] = {};
    }
    if (config && config[Constants.WINDOW_NAME_BOOK].length <= 0 && config[Constants.WINDOW_NAME_QUOTE_CHART].length <= 0
      && (isBillet || !config[Constants.WINDOW_NAME_BILLET_ROOT])) {
      localStorage.removeItem(Constants.COOKIE_CONFIG_CARDS_WKS);
    } else {
      localStorage.setItem(Constants.COOKIE_CONFIG_CARDS_WKS, JSON.stringify(config));
    }
  }

}
